import { withFormik } from 'formik';
import { withRouter } from 'react-router-dom'
import * as yup from 'yup';
import MedicalForm from './MedicalForm';
import { medicalDocument, medicalSubDocument } from '../configData';
import { editMedicalRecords, addMedicalRecords } from '../../services'
import { toast } from 'react-toastify';
import { documentSchema } from '../documentSchema'

const validationSchema = yup.object().shape({
  subDocumentType: yup.object().shape({
    label: yup.string().required(),
    value: yup.number().required("Please select a Sub document type")
  })
}).concat(documentSchema)

// const validationSchema = yup.object().shape({
//   gyno: yup.string().required("Please enter doctor's name"),
//   hospital: yup.string().required("Please enter hospital name"),
//   phone: yup.string().required("Please enter phone number"),
//   document: yup.object().shape({
//     documentType: yup.number().required("Select type of document"),
//     appointment: yup.date().max(new Date(), "Please enter a valid date"),
//     description: yup.string().required("description is required"),
//     title: yup.string().required("Title is required")
//   })
// })

const EnhancedMedicalRecord = withFormik({
  enableReinitialize: true, //props.formType == "edit",
  mapPropsToValues: (props) => ({
    medicalId: props.medicalId || '',
    subDocumentType: props.subDocumentType || {},
    gyno: props.gyno || '',
    hospital: props.hospital || '',
    phone: props.phone || '',
    document: {
      documentType: props.documentType['value'],
      appointment : props.appointment,
      description: props.description || '',
      title: props.title || '',
      files: []
    },
    redirect: false,
    files: props.files || []
  }),
  mapPropsToStatus: (props) => ({
    subDocumentsOption: medicalSubDocument,
    documentsOption: medicalDocument,
    documentType: props.documentType,
    name: "doctor",
    redirect: false,
    files: props.files || [] 

  }),
  handleSubmit: (values, { setStatus, setSubmitting, resetForm, props }) => {
    console.log(values);    

    const formdata = new FormData();
    formdata.append('data', JSON.stringify(values));

    for(let file of values.document.files) {
      formdata.append("files", file);
    }

    if(props.formType == "edit") {
      editMedicalRecords(formdata)
        .then(res => {
          toast.success("Your record edited successfully")
          props.history.push("/personalhealthrecord/generalmedicalrecord");
          return;
        })
    } else {

      addMedicalRecords(formdata)
      .then((res) => { 
        toast.success("Your record added successfully");
        if(values.redirect == true) {
          props.history.push("/personalhealthrecord/generalmedicalrecord")
          return;
        }
        else {
          resetForm();
          setSubmitting(false);
          props.handleNewRecord(res.data.record);
          return;
        }
      });
    }
  },
  validationSchema: validationSchema

})(MedicalForm);

EnhancedMedicalRecord.defaultProps = {
  appointment: null
}

export default withRouter(EnhancedMedicalRecord);


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/GeneralMedicalRecord/EnhancedMedicalRecord.js